module.exports = __webpack_public_path__ + "img/page_num_next.80b1d7b9.svg";